import { render, staticRenderFns } from "./Messaging.vue?vue&type=template&id=1b4efac5"
import script from "./Messaging.vue?vue&type=script&lang=js"
export * from "./Messaging.vue?vue&type=script&lang=js"
import style0 from "./Messaging.vue?vue&type=style&index=0&id=1b4efac5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports